import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';

export function createPermissionLevelSecurityInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_BEGIN,
    });
    const { projectId, version, data, selectedCollection } = args;
    const { uuid: collectionUuid, permissionLevelSecurity = [] } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/security/${collectionUuid}/collection`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          toast.success(
            permissionLevelSecurity && permissionLevelSecurity.length
              ? 'Permission Level Security Updated Successfully !'
              : 'Permission Level Security Created Successfully !',
          );
          dispatch({
            type: COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_SUCCESS,
            data: res,
          });
          Mixpanel.track(
            permissionLevelSecurity && permissionLevelSecurity.length
              ? 'Updated collection permission level security'
              : 'Created collection permission level security',
          );
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track(
            permissionLevelSecurity && permissionLevelSecurity.length
              ? 'Failed to update collection permission level security'
              : 'Failed to create collection permission level security',
          );
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreatePermissionLevelSecurityInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createPermissionLevelSecurityInCollectionPending: true,
        createPermissionLevelSecurityInCollectionError: null,
      };

    case COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_SUCCESS:
      return {
        ...state,
        createPermissionLevelSecurityInCollectionPending: false,
        createPermissionLevelSecurityInCollectionError: null,
      };

    case COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createPermissionLevelSecurityInCollectionPending: false,
        createPermissionLevelSecurityInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_PERMISSION_LEVEL_SECURITY_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createPermissionLevelSecurityInCollectionError: null,
      };

    default:
      return state;
  }
}
